module.exports = __webpack_public_path__ + "images/embed/user_delete.png";